import { useContext } from "react";
import AppContext from "../services/context.js";
import PageTemplate from "../components/PageTemplate.jsx";
import SearchResult from "../components/SearchResult.jsx";
import AiSearchResult from "../components/AiSearchResult.jsx";
import { usePageTitle } from "../hooks/usePageTitle.js";

const SearchPage = () => {

  const { loading, searchResults, individualResult, searchTerm, isAiMode, activeFilters } = useContext(AppContext)
  usePageTitle('Busca em Fitoterapia');
  const hasSubmittedFilters = Boolean(
    activeFilters?.therapeuticEffects?.length || activeFilters?.categories?.length
  );

  return <PageTemplate>
    <h1 className="sr-only">GreenBook — Busca em Fitoterapia</h1>
    {isAiMode ? (
      <AiSearchResult />
    ) : (
      <>
        {/* Mostra o resultado da busca */}
        {Boolean(searchResults.length && !individualResult.title) && <SearchResult />}
        {/* Retorna vazio caso não encontre nada */}
        {Boolean(!searchResults.length && !loading && (searchTerm || hasSubmittedFilters) && !individualResult.title) && (
          <div className="text-center opacity-50 my-8">
            Não foram encontrados resultados para sua busca
          </div>
        )}
      </>
    )}
  </PageTemplate>;
};

export default SearchPage;
